import angular from 'angular';
import components from './components';

export default angular.module('mergeContact.scenes.selectMergeContactType', [
  components,
]).name;
